export default function checkoutValidation() {
    $ = jQuery;

    jQuery(document.body).on('checkout_error', function (e) {
        var selectedPaymentMethod = jQuery(
            'input[name="payment_method"]:checked'
        ).val();

        if (selectedPaymentMethod === 'ppcp-gateway') {
            wcMSCupdateSession(true);
        }
    });

    const $form = $('#js-checkout-form');

    $form.on('submit', function (e) {
        e.preventDefault();
        wcMSCupdateSession();
    });

    jQuery(document).ajaxComplete(function () {
        if (
            jQuery('body').hasClass('woocommerce-checkout') ||
            jQuery('body').hasClass('woocommerce-cart')
        ) {
            jQuery('html, body').stop();
        }
    });

    function normalizePhoneValue(rawValue, dialCode) {
        const value = (rawValue || '').trim();
        const countryDialCode = (dialCode || '').replace(/\D/g, '');

        if (!value || !countryDialCode) {
            return value;
        }

        let numericValue = value.replace(/[^\d+]/g, '');

        if (numericValue.startsWith('+')) {
            numericValue = numericValue.slice(1);
        }

        if (numericValue.startsWith(countryDialCode)) {
            numericValue = numericValue.slice(countryDialCode.length);
        }

        const nationalNumber = numericValue.replace(/\D/g, '');

        return nationalNumber ? `+${countryDialCode}${nationalNumber}` : value;
    }

    function getBillingPhonePayloadValue(formEl) {
        if (!formEl) {
            return null;
        }

        const billingPhoneHiddenEl = formEl.querySelector(
            'input[name=billing_phone]'
        );
        const billingPhoneFakeEl = formEl.querySelector(
            'input[name=fake_phone]'
        );
        if (!billingPhoneHiddenEl || !billingPhoneFakeEl) {
            return null;
        }

        const itiInstance =
            window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance
                ? window.intlTelInputGlobals.getInstance(billingPhoneFakeEl)
                : null;
        const selectedCountryData = itiInstance
            ? itiInstance.getSelectedCountryData()
            : null;
        const itiContainer = billingPhoneFakeEl.closest('.iti');
        const phoneCodeEl = itiContainer
            ? itiContainer.querySelector('.iti__selected-dial-code')
            : formEl.querySelector('.iti__selected-dial-code');

        const billingPhoneVal = billingPhoneFakeEl.value;
        const phoneCodeVal =
            selectedCountryData && selectedCountryData.dialCode
                ? selectedCountryData.dialCode
                : phoneCodeEl
                ? phoneCodeEl.textContent
                : '';

        return normalizePhoneValue(billingPhoneVal, phoneCodeVal);
    }

    function syncBillingPhoneHiddenField(formEl) {
        if (!formEl) {
            return;
        }

        const billingPhoneHiddenEl = formEl.querySelector(
            'input[name=billing_phone]'
        );
        if (!billingPhoneHiddenEl) {
            return;
        }

        const billingPhonePayloadValue = getBillingPhonePayloadValue(formEl);
        billingPhoneHiddenEl.value = billingPhonePayloadValue || '';
    }

    function hydrateFakePhoneFromHidden(formEl) {
        if (!formEl) {
            return;
        }

        const billingPhoneHiddenEl = formEl.querySelector(
            'input[name=billing_phone]'
        );
        const billingPhoneFakeEl = formEl.querySelector(
            'input[name=fake_phone]'
        );

        if (
            !billingPhoneHiddenEl ||
            !billingPhoneFakeEl ||
            billingPhoneFakeEl.value
        ) {
            return;
        }

        const hiddenValue = (billingPhoneHiddenEl.value || '').trim();
        if (!hiddenValue) {
            return;
        }

        const itiContainer = billingPhoneFakeEl.closest('.iti');
        const phoneCodeEl = itiContainer
            ? itiContainer.querySelector('.iti__selected-dial-code')
            : formEl.querySelector('.iti__selected-dial-code');
        const phoneCodeVal = phoneCodeEl ? phoneCodeEl.textContent : '';
        const dialDigits = (phoneCodeVal || '').replace(/\D/g, '');

        if (!dialDigits) {
            billingPhoneFakeEl.value = hiddenValue.replace(/^\+/, '');
            return;
        }

        const escapedDialDigits = dialDigits.replace(
            /[-/\\^$*+?.()|[\]{}]/g,
            '\\$&'
        );
        const dialCodePrefixRegex = new RegExp(`^\\+?${escapedDialDigits}\\s*`);

        billingPhoneFakeEl.value = hiddenValue
            .replace(dialCodePrefixRegex, '')
            .replace(/[^\d]/g, '');
    }

    function bindBillingPhoneSyncEvents(formEl) {
        if (!formEl) {
            return;
        }

        const billingPhoneFakeEl = formEl.querySelector(
            'input[name=fake_phone]'
        );
        if (!billingPhoneFakeEl) {
            return;
        }

        if (billingPhoneFakeEl.dataset.phoneSyncBound === '1') {
            return;
        }

        const syncHiddenPhone = () => {
            syncBillingPhoneHiddenField(formEl);
        };

        ['input', 'change', 'blur', 'keyup'].forEach(eventName => {
            billingPhoneFakeEl.addEventListener(eventName, syncHiddenPhone);
        });
        billingPhoneFakeEl.addEventListener('countrychange', syncHiddenPhone);
        billingPhoneFakeEl.dataset.phoneSyncBound = '1';

        syncHiddenPhone();
    }

    function wcMSCupdateSession(offScroll = false) {
        generateRecaptcha()
            .then(() => {
                const billingPhonePayloadValue = getBillingPhonePayloadValue(
                    $form[0]
                );
                syncBillingPhoneHiddenField($form[0]);

                let data = $form.serializeArray().concat({
                    name: 'action',
                    value: 'mda_wc_checkout',
                });
                if (billingPhonePayloadValue !== null) {
                    const billingPhoneData = data.find(
                        item => item.name === 'billing_phone'
                    );
                    if (billingPhoneData) {
                        billingPhoneData.value = billingPhonePayloadValue;
                    }
                }

                let checkBillingType = data.find(
                    item => item.name === 'billing_type'
                );
                if (!checkBillingType)
                    data.push({
                        name: 'billing_type',
                        value: $('input[name=billing_type]').val(),
                    });

                $.ajax({
                    type: 'post',
                    url:
                        base_url +
                        '/wp-json/wc/v3/shop/checkout-form-validation',
                    data: data,
                    success: function (response) {
                        if (response.messages.length > 0) {
                            showErrors(response.messages, $form, offScroll);
                        }

                        if (response.result == 'success') {
                        } else {
                        }
                    },
                });
            })
            .catch(() => {
                showErrors(
                    [
                        {
                            type: 'global',
                            text: 'Nie udało się zweryfikować reCAPTCHA. Spróbuj ponownie.',
                        },
                    ],
                    $form,
                    offScroll
                );
            });
    }

    hydrateFakePhoneFromHidden($form[0]);
    bindBillingPhoneSyncEvents($form[0]);

    jQuery(document.body).on('updated_checkout', function () {
        hydrateFakePhoneFromHidden($form[0]);
        bindBillingPhoneSyncEvents($form[0]);
        syncBillingPhoneHiddenField($form[0]);
    });

    function generateRecaptcha() {
        return new Promise((resolve, reject) => {
            if (typeof grecaptcha === 'undefined') {
                reject();
                return;
            }

            const siteKey =
                (typeof mdaRecaptcha !== 'undefined' && mdaRecaptcha.siteKey) ||
                null;

            if (!siteKey) {
                reject();
                return;
            }

            grecaptcha.ready(function () {
                grecaptcha
                    .execute(siteKey, {
                        action: 'submit',
                    })
                    .then(function (token) {
                        var recaptchaResponse = document.querySelector(
                            'input[name="recaptcha_response"]'
                        );

                        if (!recaptchaResponse) {
                            recaptchaResponse = document.createElement('input');
                            recaptchaResponse.type = 'hidden';
                            recaptchaResponse.name = 'recaptcha_response';
                            document
                                .querySelector('form.checkout')
                                .appendChild(recaptchaResponse);
                        }

                        recaptchaResponse.value = token;
                        resolve(token);
                    })
                    .catch(reject);
            });
        });
    }

    function showErrors(messages, form, offScroll = false) {
        $('.js-cf-error').remove();
        form.find('input').removeClass('-error');

        messages.forEach(function (msg, key) {
            if (msg.type == 'field') {
                const selector =
                    msg.key === 'billing_phone'
                        ? '[name="fake_phone"]'
                        : '[name="' + msg.key + '"]';
                const formField = form.find(selector);
                if (msg.key == 'terms') {
                    formField.parent().addClass('-error');
                } else {
                    formField
                        .addClass('-error')
                        .parent()
                        .append(
                            '<span class="js-cf-error form-group__message -error">' +
                                msg.text +
                                '</span>'
                        );
                }

                if (offScroll == false) {
                    if (key === 0) {
                        setTimeout(() => {
                            $('html, body').animate(
                                {
                                    scrollTop: formField.offset().top - 100,
                                },
                                1000
                            );
                        }, 100);
                    }
                }
            }
        });
    }

    function toggleCompanyField(checked) {
        var companyField = $('#js-checkout-form #billing_company_field');
        const nipField = $('#js-checkout-form #billing_tax_no_field');

        if (checked) {
            companyField.slideDown();
            nipField.slideDown();
        } else {
            companyField.slideUp();
            nipField.slideUp();
        }
    }

    toggleCompanyField(false);

    $('input[name=billing_type]').click(function () {
        const checked = $(this).prop('checked');
        const value = checked ? 'company' : 'private';

        $(this).val(value);
        toggleCompanyField(checked);
    });

    function updateCheckAllButton() {
        var totalCheckboxes = $(
            'input[name="acceptance"], input[name="acceptance_legal"], input[name="acceptance_contract"]'
        ).length;
        var checkedCount =
            $('input[name="acceptance"]:checked').length +
            $('input[name="acceptance_legal"]:checked').length +
            $('input[name="acceptance_contract"]:checked').length;
        $('.js-check-all').prop('checked', checkedCount === totalCheckboxes);
    }

    $('.js-check-all').on('click', function () {
        var isChecked = $(this).is(':checked');
        $(
            'input[name="acceptance"], input[name="acceptance_legal"], input[name="acceptance_contract"]'
        ).prop('checked', isChecked);
    });

    $(
        'input[name="acceptance"], input[name="acceptance_legal"], input[name="acceptance_contract"]'
    ).change(function () {
        updateCheckAllButton();
    });

    updateCheckAllButton();
}

document.addEventListener('DOMContentLoaded', function () {
    if (
        window.location.search.includes('register') ||
        window.location.search.includes('login') ||
        window.location.search.includes('checkout')
    ) {
        const errorBox = document.querySelector(
            '.woocommerce-notices-wrapper, .woocommerce-error'
        );
        if (errorBox) {
            errorBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const errorBox = document.querySelector(
        '.woocommerce-error, .woocommerce-notices-wrapper'
    );
    if (errorBox && errorBox.textContent.trim().length > 0) {
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Autofocus na polu hasła, jeśli błąd dotyczy hasła
        if (errorBox.textContent.includes('Hasło')) {
            const passwordField = document.querySelector('#account_password');
            if (passwordField) passwordField.focus();
        }
    }
});
